import { render, staticRenderFns } from "./FeathersAutocomplete.vue?vue&type=template&id=2778e868&"
import script from "./FeathersAutocomplete.vue?vue&type=script&lang=js&"
export * from "./FeathersAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2778e868')) {
      api.createRecord('2778e868', component.options)
    } else {
      api.reload('2778e868', component.options)
    }
    module.hot.accept("./FeathersAutocomplete.vue?vue&type=template&id=2778e868&", function () {
      api.rerender('2778e868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeathersAutocomplete.vue"
export default component.exports